<div class="home">
  <div class="header">
    <img src="/assets/images/rea/rea-logo-payoff-lg.jpg" width="300px">
  </div>
  <div class="body">
    <h2 class="">Energizing Economies Initiative</h2>
  </div>
</div>
